import { DOCUMENT } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
/* import {
  NgxNavbarCollapseComponent,
  NgxNavbarDynamicExpandDirective,
} from "ngx-bootstrap-navbar"; */
import { StorageService } from "src/app/features/http-services/storage.service";
import { MenuConfigService } from "../../services/menu-config.service";
import { SidenavService } from "../../services/sidenav.service";
import { residentialMenuIsCSR } from "../../../constants/menu/residential.config";
import { UserService } from "../../../user/services/user.service";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { ConfirmationDialogComponent } from "../../../components/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'xchange-site-sidenav',
  templateUrl: './site-sidenav.component.html',
  styleUrl: './site-sidenav.component.scss'
})
export class SiteSidenavComponent {
  accountName: string | null = "";
  accountId: string | null = "";
  accountAddress: string | null = "";
  displayCustomerNumber: any;
  customerName: any;

  logo: string = "";
  isMobile: boolean | any;
  minimumHeight: any;
  innerHeight: number = window.innerHeight;
  zoomLevel: number = 100;
  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    const screenWidth = window.innerWidth;
    const realScreenWidth = window.screen.width;
    this.zoomLevel = Math.round((screenWidth / realScreenWidth) * 100);
    if (!this.isMobile) {
      const scrollerElement = document.getElementsByClassName(
        "ng-sidebar__content"
      )[0];
      if (scrollerElement) {
        document.body.classList.add("add-scroll");
      }
      const xsmall = document.querySelectorAll(".main-side-bar-container");
      xsmall.forEach((element) => {
        const elem = element as HTMLElement;
        if (window.screen.width > 1024) {
          const screenHeight: number = window.innerWidth;
          elem.style.height = `${screenHeight}px`;
        } else {
          const screenHeight: number = window.innerHeight;
          elem.style.height = `${screenHeight}px`;
        }
      });
    }
    this.onResizeScreenHideMenuDropdown();
    this.isMobile = window.innerWidth < 1024;
    return this.isMobile;
  }

  @ViewChildren("collapse")
  //ngxNavbarCollapses!: QueryList<NgxNavbarDynamicExpandDirective>;
  menuCurrentState!: boolean;
  menuConfig: Array<any> = []; //commercialMenuIsCSR;
  project: string = "";
  modalRef!: BsModalRef;

  constructor(
    private r: Router,
    private sideNav: SidenavService,
    private cd: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document,
    private ar: ActivatedRoute,
    private storageService: StorageService,
    private menuConfigService: MenuConfigService,
    private router: Router,
    private userService: UserService,
    private modalService: BsModalService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.project = this.ar.snapshot.data["project"];
    this.menuConfig = residentialMenuIsCSR;
    this.storageService.getItem("userInfo").subscribe((userData: any) => {
      this.accountName = userData?.name;
      this.menuConfigService
        .getMenuData(this.project, userData)
        .subscribe((menu) => {
          this.menuConfig = menu;
        });
    });
    this.accountId = localStorage.getItem("accountNumber");
    this.accountAddress = localStorage.getItem("customerAddress");
    this.setLogo(this.accountName);
    this.storageService.getselectedAccount().subscribe((data: any) => {
      if (data) {
        if (localStorage.getItem("accountNumber")) {
          this.displayCustomerNumber = localStorage
            .getItem("accountNumber")
            ?.split("_")[0];
        }
        this.accountAddress = localStorage.getItem("customerAddress");

        this.setLogo(data?.name);
      }
    });
    this.storageService.getItem("userInfo").subscribe((res) => {
      this.setLogo(res?.name);
    });
    this.storageService.getItem("accountData").subscribe((res: any) => {
      this.customerName = res?.accountName;
      this.displayCustomerNumber = +res?.customerNumber?.split("_")[0];
    });
  }

  ngAfterViewInit() {
    this.sideNav.currentState.subscribe((open) => {
      this.menuCurrentState = open;
      if (!open) {
        /* this.ngxNavbarCollapses.forEach((c: any) => {
          c.isCollapsed = true;
        }); */
        const buttonElements = document.getElementsByClassName("rotate90");
        for (let i = 0; i <= buttonElements.length; i++) {
          if (buttonElements[i] && buttonElements[i].classList)
            buttonElements[i].classList.remove("rotate90");
        }
      }
    });

    this.cd.detectChanges();
  }

  toggleMenu() {
    if (this.menuCurrentState) {
      if (!this.isMobile) {
        const minset: any = localStorage.getItem("minHeight");
        const setagain = document.querySelectorAll(".main-side-bar-container");
        setagain.forEach((element) => {
          const elem = element as HTMLElement;
          elem.style.height = `${minset}px`;
        });
      }
      this.sideNav.hide();
    } else {
      if (!this.isMobile) {
        const xsmall = document.querySelectorAll(".main-side-bar-container");
        xsmall.forEach((element) => {
          const elem = element as HTMLElement;
          if (window.screen.width > 1024) {
            const screenHeight: number = window.innerWidth;
            elem.style.height = `${screenHeight}px`;
          } else {
            const screenHeight: number = window.innerHeight;
            elem.style.height = `${screenHeight}px`;
          }
        });
      }
      this.sideNav.show();
    }
    return true;
  }

  expandSideNav() {
    this.sideNav.show();
  }

  navigateToRoute(
    path: string,
    e: any,
    isExternal: boolean,
    level1: any = null
  ) {
    if (!this.isMobile) {
      const scrollerElement = document.getElementsByClassName(
        "ng-sidebar__content"
      )[0];
      if (scrollerElement) {
        this.renderer.setStyle(scrollerElement, "overflow", "hidden");
      }
      const minset: any = localStorage.getItem("minHeight");
      const setagain = document.querySelectorAll(".main-side-bar-container");
      setagain.forEach((element) => {
        const elem = element as HTMLElement;
        elem.style.height = `${minset}px`;
      });

      const scroll = document.querySelectorAll(".custom-scrollbar");
      scroll.forEach((element) => {
        const elem = element as HTMLElement;
        elem.scrollTop = 0;
      });
    }
    const navEle = e.target;
    if (isExternal) {
      if (e.target.text == "EDI Setup") {
        this.openConfirmationModal({
          title: "B2B EDI Software Required",
          content: "Xchange requires B2B EDI software",
          primaryActionLabel: "Continue",
          secondaryActionLabel: "Cancel",
          onPrimaryAction: () => {
            window.open(path);
            this.modalService.hide();
          },
          onSecondaryAction: () => {
            this.modalService.hide();
          },
        });
      } else {
        window.open(path);
      }
      return;
    }

    localStorage.setItem("path", path);

    // debugger
    const subMenu = navEle.closest(".level1-li");
    // subMenu.classList.toggle("show-pop-menu");

    subMenu.classList.remove("show-pop-menu");
    if(e.target.text == 'New Orders' || e.target.text == 'Sample Orders'){
      let orderType = (e.target.text == 'New Orders' ? "orderStandard" : "orderSample"); 
      localStorage.setItem("order-type", orderType);
      if (
        this.storageService.cartData == undefined ||
        this.storageService.cartData == "" ||
        this.storageService.cartData.hasOwnProperty("errorMessage") ||
        this.storageService.cartData?.totalItems == 0
      ) {
        this.r.navigateByUrl("/" + path);
      }else{
        let name = e.target.text == 'New Orders' ? 'new-order' : 'order-sample';
        this.router.navigate([`residential/products/${name}`]);
      }
      
    }else{
      this.r.navigateByUrl("/" + path);
    }
    
    // subMenu.classList.toggle("show-pop-menu");
    subMenu.classList.remove("show-pop-menu");
    this.sideNav.hide();
    return true;
  }

  handleCollapse(level: string, index: number) {
    const collapseElement = this.document.getElementById(
      level + "-collapse-" + index
    );
    const btnElement = this.document.getElementById(level + "-btn-" + index);
    if (collapseElement?.classList.contains("sub-menu")) {
      btnElement?.classList.toggle("nav-arrow");
      btnElement?.classList.toggle("rotate90");
    }
    /* this.ngxNavbarCollapses.forEach((c: any) => {
      if (
        c.nativeElement.id !== level + "-collapse-" + index &&
        c.nativeElement?.id?.includes(level)
      ) {
        c.isCollapsed = true;
      }
    }); */
    const collapseBtnList = document.querySelectorAll(
      "[id^='" + level + "-btn-']"
    );
    collapseBtnList.forEach((btn: any) => {
      if (btn.id !== level + "-btn-" + index) {
        btn.classList.remove("rotate90");
      }
    });
    return true;
  }
  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (!this.isMobile) {
        const minset: any = localStorage.getItem("minHeight");
        const setagain = document.querySelectorAll(".main-side-bar-container");
        setagain.forEach((element) => {
          const elem = element as HTMLElement;
          elem.style.height = `${minset}px`;
        });
      }
    }
  }

  showTooltip = false;
  onShowMenu(e: any, name: any) {
    if (!this.isMobile) {
      const scrollerElement = document.getElementsByClassName(
        "ng-sidebar__content"
      )[0];
      if (scrollerElement) {
        document.body.classList.add("add-scroll");
      }
      const xsmall = document.querySelectorAll(".main-side-bar-container");
      xsmall.forEach((element) => {
        const elem = element as HTMLElement;
        const innerHeight = window.innerHeight;
        if (this.zoomLevel <= 80) {
          const calhieght = innerHeight ;
          //elem.style.height = `${calhieght}px`;
        } else {
          //elem.style.height = `${innerHeight}px`;
        }
        const xsmall = document.querySelectorAll(".sub-menu");
        if (name === "Finance") {
          if (window.screen.width > 1024) {
            xsmall.forEach((element) => {
              const elem = element as HTMLElement;
            elem.style.top='-147px';
            })
       
            const scrollOptions: ScrollIntoViewOptions = {
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            };
            elem.scrollIntoView(scrollOptions);
          }
      
        }
        else{
          xsmall.forEach((element) => {
            const elem = element as HTMLElement;
          elem.style.top='0px';
          })
        }
      });
    }

    this.showTooltip = false;
    const showPopup = this.document.querySelector(".show-pop-menu");
    showPopup?.classList.remove("show-pop-menu");
    const navItem = e.target.closest(".level1-li");
    navItem.classList.toggle("show-pop-menu");
    return true;
  }

  onClickedOutsideOfMenu(name: string, i: number) {
    const navItem = this.document.querySelector("." + name + i);
    navItem?.classList.remove("show-pop-menu");
  }

  onResizeScreenHideMenuDropdown() {
    const showPopup = this.document.querySelector(".show-pop-menu");
    showPopup?.classList.remove("show-pop-menu");
  }

  navigateToUserSearch() {
    this.unset()
    const baseUrlPath = this.router.url.split("?")[0].includes("commercial")
      ? "commercial"
      : "residential";
    this.storageService.clear();
    this.userService.setAccountInfoState(false);
    this.sideNav.hide();
    this.r.navigate(["/" + baseUrlPath + "/account/search"]);

  }

  private setLogo(name: any) {
    if (name != null) {
      let index = name.indexOf(" ");
      this.logo = name.substring(0, 1) + name.substring(index + 1, index + 2);
    }
  }
  ngOnDestroy() {}

  openConfirmationModal(data = {}) {
    const initialState: ModalOptions = {
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: {
        ...data,
      },
    };
    this.modalRef = this.modalService.show(
      ConfirmationDialogComponent,
      Object.assign(initialState, {
        id: "side-nav-confirmation",
        class: "modal-md modal-dialog-centered",        
        backdrop: "static",
        keyboard: false,
      })
    );
  }

  showSubMenu(collapseId:any){
    const slides = document.getElementsByClassName('mx-ngx-sub-menu');
    for (let i = 0; i < slides.length; i++) {
        const slide = slides[i] as HTMLElement;
        if ( slide.style.display !== 'none' && slide.id != collapseId ) {
          slide.style.display = 'none';
      }
       // slide.style.display = "none";
    }

    let e:any = document.getElementById(collapseId);
    if ( e.style.display !== 'none' ) {
        e.style.display = 'none';
    } else {
        e.style.display = 'block';
    }
  }

  unset(){
    const dynamicPadding = document.querySelectorAll(".mobile-top-bar");
    dynamicPadding.forEach((element) => {
      const elem = element as HTMLElement;
      let paddingValue = "";
        paddingValue =  "5px 0";
      elem.style.padding = paddingValue;
    });
  }
}
